import api from "../api";

export const getUsers = (params) =>
  api.get("/users", { params });

export const addUser = (payload) => api.post("/users/add", payload);

export const updateUser = (id, payload) =>
  api.post(`/users/edit/${id}`, payload);

export const deleteUser = (id) =>
  api.post(`/users/delete/${id}`);

export const restoreUser = (id) =>
  api.post(`/users/restore/${id}`);

export const getUserDetail = (id) =>
  api.get(`/users/${id}/detail`);

